import React, { useMemo } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highcharts-gantt';
import ExportData from 'highcharts/modules/export-data';
import Exporting from 'highcharts/modules/exporting';
import patternFill from 'highcharts/modules/pattern-fill';
import HighchartsTreeGrid from 'highcharts/modules/treegrid';

// Initialize Highcharts modules
patternFill(Highcharts);
HighchartsTreeGrid(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);

const allSeries = [
  { name: 'Active', key: 'activeValue', color: '#2211A7' },
  { name: 'Opportunity', key: 'opportunityValue', color: '#BDB5F8' },
  { name: 'Complete', key: 'completeValue', color: '#4BC11F' },
  { name: 'Committed', key: 'committedValue', color: '#AA7BE0' },
];

const BarChart = (props) => {
  const {
    data = [],
    height = '600px',
    title = '',
    subtitle = '',
    xAxisTitle = '',
    yAxisTitle = '',
    seriesName = 'value',
  } = props;

  const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const series = allSeries.map(({ name, key, color }) => ({
    name,
    color,
    data: data.map((item) => ({
      name: item.name,
      y: item[key] ?? 0,
    })),
  }));

  const chartOptions = useMemo(() => {
    return {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Inter, sans-serif',
        },
      },
      title: {
        text: title,
        style: {
          fontFamily: 'Inter, sans-serif',
        },
      },
      subtitle: {
        text: subtitle,
        style: {
          fontFamily: 'Inter, sans-serif',
        },
      },
      xAxis: {
        type: 'category',
        title: {
          text: xAxisTitle,
        },
        labels: {
          rotation: 0,
          style: {
            fontSize: '13px',
            fontFamily: 'Inter, sans-serif',
            // fontWeight: "bold"
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: yAxisTitle,
          style: {
            fontFamily: 'Inter, sans-serif',
          },
        },
        stackLabels: {
          enabled: true,
          style: {
            fontFamily: 'Inter, sans-serif',
            color:
              // theme
              (Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color) ||
              'gray',
          },
          formatter: function () {
            return '$' + numberFormatter.format(this.total);
          },
          style: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: 'normal',
          },
        },
      },
      legend: {
        enabled: false, // Disable the legend
      },
      tooltip: {
        formatter: function () {
          const point = this.point;
          const seriesName = this.series.name;
          const pointValue = Highcharts.numberFormat(point.y, 2, '.', ',');
          const stackTotal = Highcharts.numberFormat(point.stackTotal, 2, '.', ',');

          return `${seriesName}: <b>$${pointValue}</b><br/>Total: <b>$${stackTotal}</b>`;
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false,
            style: {
              fontFamily: 'Inter, sans-serif',
            },
          },
        },
      },
      series,
    };
  }, [title, subtitle, xAxisTitle, yAxisTitle, data]);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType={'chart'}
      options={chartOptions}
      containerProps={{ style: { height: height, width: '100%' } }}
      oneToOne={true}
      allowChartUpdate={true}
      immutable={true}
    />
  );
};

export default BarChart;
